export const VERSION = '9.0.6';
